// extracted by mini-css-extract-plugin
export var bodyRow = "_h0-d";
export var cardColumns = "_h0-e";
export var ellipsesOverflow = "_h0-2";
export var flatBottomCorners = "_h0-3";
export var flatTopCorners = "_h0-4";
export var headerActionsDropdown = "_h0-f";
export var headerBottomRow = "_h0-c";
export var headerTopRow = "_h0-b";
export var orderDetailsWrapper = "_h0-0";
export var orderInfoContainer = "_h0-1";
export var productDetails = "_h0-9";
export var productImage = "_h0-5";
export var responsiveTable = "_h0-8";
export var shipmentContainer = "_h0-a";
export var tableBottomLeft = "_h0-6";
export var tableBottomRight = "_h0-7";
export var trackingLink = "_h0-g";